module.exports = __webpack_public_path__ + "assets/img/home-typical-scenarios-light.8c86a63e.png";